
import Jobs from '../../components/Layouts/Marketplace/Jobs/Jobs';
export default function JobsLanding() {
    return <Jobs />
}
